import SrQiankunAdd from "./SrQiankunAdd.vue";

SrQiankunAdd.install = function(Vue) {
  Vue.component(SrQiankunAdd.name, SrQiankunAdd);
};

export default SrQiankunAdd;


// WEBPACK FOOTER //
// ./packages/SrQiankunAdd/index.js